import { module } from 'modujs';
import gsap from 'gsap'

const SPEED = 1;

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.delta = SPEED;

        this.reversed = this.getData('reversed') != null
        this.viewportSensitive = this.getData('viewport-sensitive') != null

        this.originalHTML = this.el.innerHTML;

        this.compute()

        this.renderBind = this.render.bind(this)
        if(!this.viewportSensitive) this.render()

        this.checkResizeBind = this.checkResize.bind(this)
        window.addEventListener('resize', this.checkResizeBind)
    }

    checkResize() {
        if(!this.resizeTick) {
            this.resizeTick = true
            requestAnimationFrame(() => {
                if(this.viewportWidth != window.innerWidth)
                    this.compute()
                this.resizeTick = false
            })
        }
    }

    compute() {
        // Reset html
        this.el.innerHTML = this.originalHTML;

        // Compute viewport width and duplicate content if needed to fit at least entire screen's width
        this.viewportWidth = window.innerWidth;
        this.$outer = this.$('outer')[0];
        this.contentWidth = this.$outer.children[0].getBoundingClientRect().width
        if(!this.contentWidth) {
            console.error('[Rail] content is empty');
            return false
        }
        if(this.contentWidth < this.viewportWidth) {
            const duplicatesNeeded = Math.floor(this.viewportWidth / this.contentWidth);

            for(let i = 0; i <= duplicatesNeeded; i++) {
                const node = this.$outer.children[0].cloneNode(true)
                this.$outer.appendChild(node);
            }
        }

        // Duplicate inner element
        this.el.appendChild(this.$outer.cloneNode(true))

        this.currentOffset = 0;

        this.$outer = this.$('outer');
    }

    render() {
        if(window.scroll.velocity) {
            this.delta = SPEED * (window.scroll.velocity > 0 ? 1 : -1);
            this.delta+= window.scroll.velocity * 0.2;

            if(this.reversed) this.delta*=-1
        }

        this.currentOffset += this.delta;

        if(this.delta > 0) {
            if(this.currentOffset >= 0) this.currentOffset-=this.contentWidth
        } else {
            if(this.currentOffset < -this.contentWidth) this.currentOffset+=this.contentWidth
        }

        gsap.set(this.$outer, { x: this.currentOffset, force3D: true })
    }

    inview(e) {
        const { target, way } = e

        if(target == this.el) {
            if(!this.active && way == 'enter') {
                gsap.ticker.add(this.renderBind);
                this.active = true
            } else if(this.active && way == 'leave') {
                gsap.ticker.remove(this.renderBind);
                this.active = false
            }
        }
    }

    destroy() {
        gsap.ticker.remove(this.renderBind);

        window.removeEventListener('resize', this.checkResizeBind)
    }
}
